import { useState, useEffect } from 'react';
import { X, Phone, Headphones, Clock } from 'lucide-react';
import { getSaveaPhone, getSaveaPhoneTel } from '../config/phoneConfig';

const POPUP_CONTENT = {
  FR: {
    electricity: {
      title: "Vous ne trouvez pas ce que vous cherchez ?",
      subtitle: "Nos conseillers énergie sont là pour vous aider",
      description: "Appelez gratuitement un expert SAVEA pour comparer les offres d'électricité et trouver la meilleure pour vous.",
      cta: "Appeler un Conseiller",
      hours: "Lundi - Samedi : 8h - 21h",
      free: "Service Gratuit"
    },
    internet: {
      title: "Vous ne trouvez pas ce que vous cherchez ?",
      subtitle: "Nos conseillers internet sont là pour vous aider",
      description: "Appelez gratuitement un expert SAVEA pour comparer les offres internet et trouver la meilleure pour vous.",
      cta: "Appeler un Conseiller",
      hours: "Lundi - Samedi : 8h - 21h",
      free: "Service Gratuit"
    }
  },
  ES: {
    electricity: {
      title: "No encuentras lo que buscas?",
      subtitle: "Nuestros asesores de energía están aquí para ayudarte",
      description: "Llama gratis a un experto SAVEA para comparar las ofertas de luz y encontrar la mejor para ti.",
      cta: "Llamar a un Asesor",
      hours: "Lunes - Sábado : 8h - 21h",
      free: "Servicio Gratuito"
    },
    internet: {
      title: "No encuentras lo que buscas?",
      subtitle: "Nuestros asesores de internet están aquí para ayudarte",
      description: "Llama gratis a un experto SAVEA para comparar las ofertas de internet y encontrar la mejor para ti.",
      cta: "Llamar a un Asesor",
      hours: "Lunes - Sábado : 8h - 21h",
      free: "Servicio Gratuito"
    }
  }
};

export const RetentionPopup = ({ country, vertical, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 300);
    return () => clearTimeout(timer);
  }, []);

  const content = POPUP_CONTENT[country]?.[vertical] || POPUP_CONTENT.FR.electricity;
  const phone = getSaveaPhone(country, vertical, 'LP');
  const phoneTel = getSaveaPhoneTel(country, vertical, 'LP');

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 300);
  };

  return (
    <div
      className={`fixed inset-0 z-[100] flex items-center justify-center p-4 transition-all duration-300 ${
        isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'
      }`}
      data-testid="retention-popup-overlay"
    >
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={handleClose}
      />

      {/* Popup */}
      <div
        className={`relative w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden transition-all duration-300 ${
          isVisible ? 'scale-100 translate-y-0' : 'scale-95 translate-y-4'
        }`}
        data-testid="retention-popup"
      >
        {/* Close button */}
        <button
          onClick={handleClose}
          className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 hover:text-gray-700 transition-colors z-10"
          data-testid="retention-popup-close"
        >
          <X className="w-4 h-4" />
        </button>

        {/* Header */}
        <div className="bg-gradient-to-r from-sage-700 to-sage-800 px-6 pt-8 pb-6 text-center">
          <div className="w-16 h-16 mx-auto mb-4 bg-white/15 rounded-2xl flex items-center justify-center backdrop-blur-sm">
            <Headphones className="w-8 h-8 text-white" />
          </div>
          <h2 className="text-xl font-bold text-white mb-1" data-testid="retention-popup-title">
            {content.title}
          </h2>
          <p className="text-sage-200 text-sm">
            {content.subtitle}
          </p>
        </div>

        {/* Body */}
        <div className="px-6 py-6">
          <p className="text-gray-600 text-sm text-center mb-6 leading-relaxed">
            {content.description}
          </p>

          {/* CTA Phone */}
          <a
            href={`tel:${phoneTel}`}
            className="w-full flex flex-col items-center justify-center bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-bold py-4 px-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300"
            data-testid="retention-popup-cta"
          >
            <div className="flex items-center gap-2 text-lg">
              <Phone className="w-5 h-5" />
              <span>{phone}</span>
            </div>
            <span className="text-green-100 text-xs mt-1 font-normal">{content.free}</span>
          </a>

          {/* Hours */}
          <div className="flex items-center justify-center gap-2 mt-4 text-gray-500 text-xs">
            <Clock className="w-3.5 h-3.5" />
            <span>{content.hours}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
